import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
//import intersect from '@alpinejs/intersect';
//import persist from '@alpinejs/persist';
//import anchor from '@alpinejs/anchor';
//import mask from '@alpinejs/mask';
//import focus from '@alpinejs/focus';
//import morph from '@alpinejs/morph';
//import resize from '@alpinejs/resize'
//import sort from '@alpinejs/sort'

import stores from './alpine.stores';									// Global store
import autoTransition from './alpine.auto-transition';					// Transition sugar
import panels from './alpine.panels';									// Sliding panels
import siteMessage from './alpine.site-message';						// Site message (error, warning, notice, success)
import dropdown from './alpine.dropdown';								// Drop down
import dataFetcher from './alpine.data-fetcher';						// AJAX data fetcher
import twirePageText from './alpine.twire-page-text';					// TWire page text
import link from './alpine.link';										// Adds psuedo links
import scrollTo from './alpine.scroll-to';								// Scrolls to an element
import clone from './alpine.clone';										// Clone HTML inc. reactive data
import selectLocationChanger from './alpine.select-location-changer';	// Change location on select change


/**
 * One-tune functions to do things to the DOM, etc
 */
export const initAlpine = () => {

	Alpine.plugin(collapse);  // Smoothly slides elements open/closed (accordion style)
	//Alpine.plugin(intersect); // Triggers actions when elements scroll into view
	//Alpine.plugin(persist);   // Keeps data across page refreshes using localStorage
	//Alpine.plugin(anchor);	// Positions floating elements (menus/tooltips) relative to triggers
	//Alpine.plugin(mask);	  // Formats input fields as you type (dates, phone numbers)
	//Alpine.plugin(focus);	 // Manages keyboard focus for accessibility (trapping in modals)
	//Alpine.plugin(morph);	 // Updates DOM trees while preserving state (like React's virtual DOM)
	//Alpine.plugin(resize); // Tracks element size changes via ResizeObserver (great for responsive UI)
	//Alpine.plugin(sort);   // Enables drag-and-drop reordering for lists (powered by SortableJS)

	// App Alpine
	Alpine.plugin(autoTransition);
	Alpine.plugin(stores);
	Alpine.plugin(panels);
	Alpine.plugin(siteMessage);
	Alpine.plugin(dropdown);
	Alpine.plugin(dataFetcher);
	Alpine.plugin(twirePageText);
	Alpine.plugin(link);
	Alpine.plugin(scrollTo);
	Alpine.plugin(clone);
	Alpine.plugin(selectLocationChanger);

	// Start Alpine
	window.Alpine = Alpine;
	Alpine.start();

	// TWire page text (saves having x-data on <body>
	Alpine.store('twirePageText').initFromDOM(document.body.dataset.twirePageText);

};